import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Paginator } from 'primeng/paginator';
import { Settings } from '../../lib/app.constant';
import { Router } from '@angular/router';
import { CommonService } from '../../service/common/common.service';
import { Observable, Subscription, firstValueFrom } from 'rxjs';
import { MenuItem, MessageService } from 'primeng/api';
import { AdministrationService, INavigationData, MasterdataService, StorageService } from '../../service';
import moment from 'moment';
import { AppMainComponent } from '../main-panel/app.main.component';
import { SidebarFilterComponent } from '../sidebar-filter/sidebar-filter.component';
import { select, Store } from '@ngrx/store';
import { DocumentsService } from '../../service/documents/documents.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { OverlayPanel } from 'primeng/overlaypanel';
interface Column {
  isDisabled: boolean;
  key: string;
  label: string;
}
@Component({
  selector: 'app-crud-grid',
  templateUrl: './crud-grid.component.html',
  styleUrls: ['./crud-grid.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-360deg)' })),
      transition('rotated => default', animate('2000ms ease-out')),
      transition('default => rotated', animate('2000ms ease-in'))
    ])
  ]
})
export class CrudGridComponent {
  public showFilter: boolean = false;
  @Input() buttonConfig: any;
  @Input() total_records = Settings.GridConfiguration.totalRecords;
  @Input() page_size = Settings.GridConfiguration.pageSize;
  @Input() order_type = Settings.GridConfiguration.orderType;
  @Input() default_order_by = Settings.GridConfiguration.orderBy;
  @Input() date_range = '';
  @Input() loading = false;
  @Input() grid_schema = [];
  @Input() businessUnitList = [];
  @Input() fileTypelist = [];
  @Input() fileTypeList = [];
  @Input() filteredFileTypes = [];
  @Input() documentTypeList = [];
  @Input() allcustomerList = [];
  @Input() address_type_list = [];
  @Input() connectivityProtocol = [];
  @Input() directionList = [];
  @Input() currencyList = [];
  @Input() userTypeList = [];
  @Input() companyList = [];
  @Input() featureList = [];
  @Input() customerList = [];
  @Input() sectorList = [];
  @Input() vendorList = [];
  @Input() serviceCategory = [];
  @Input() serviceType = [];
  @Input() transportMode = [];
  @Input() data = [];
  @Input() doc_type_list = [];
  @Input() module_id: any;
  // @Input() bns_users = []
  @Input() callback: (val: boolean) => void;
  @Input() viewPdf: (data: {}) => void;
  @Input() viewConfig: (data: {}) => void;
  @Output() filterModelChange = new EventEmitter<any>();
  @Input() edit: (body: {}, id: string) => void;
  @Input() addSubscription: (body: {}) => void;
  @Input() addConnectivitySetup: (body: {}) => void;
  @Input() viewConnectivitySetup: (body: {}, id: string) => void;
  @Input() editConnectivitySetup: (body: {}, id: string) => void;
  @Input() deleteConnectivitySetup: (id: string) => void;
  @Input() viewSubscription: (body: {}) => void;
  @Input() copy: (body: {}) => void;
  @Input() delete: (id: string) => void;
  @Input() sortGrid: (event: Partial<Event>) => void;
  @Input() paginateEvent: (event: Partial<Event>) => void;
  @Input() export: () => void;
  @Input() filterModel = null;
  @Input() page_number = 1;
  @Input() roleList = [];
  @Input() privilegeList: any;
  @Input() companyType: any;
  @Input() emailType: any;
  @Input() tamplateType: any;
  @Input() shipper: any;
  @Input() shipper_business_unit: any;
  @Input() name: string;
  @Input() selectedCard: any;
  @Input() isAssigned: any = false;
  debounceTimer: any;
  @Input() assign: (body: {}, id: string) => void;
  // @Input() router:Partial<Router>;
  @Output() resetFilters: EventEmitter<void> = new EventEmitter<void>();
  @Output() downloadFileData: EventEmitter<void> = new EventEmitter<void>();
  @Output() superUserEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() payloadData: EventEmitter<void> = new EventEmitter<void>();
  @Output() privilegeData: EventEmitter<void> = new EventEmitter<void>();
  @Output() sbuData: EventEmitter<void> = new EventEmitter<void>();
  @Output() vendor: EventEmitter<void> = new EventEmitter<void>();
  @Output() customer: EventEmitter<void> = new EventEmitter<void>();
  @Output() applicationData: EventEmitter<void> = new EventEmitter<void>();
  @Output() superUserData: EventEmitter<void> = new EventEmitter<void>();
  @Output() businessAllocationData: EventEmitter<void> = new EventEmitter<void>();
  @Output() viewVersion: EventEmitter<void> = new EventEmitter<void>();
  @Output() appToken: EventEmitter<void> = new EventEmitter<void>();
  @Output() durationType = new EventEmitter<void>();
  @Output() assignedInvoiced = new EventEmitter<void>();
  @Output() dateRange = new EventEmitter<any>();
  @Output() getBillingExportData = new EventEmitter<any>();
  @Output() getClientBillingExportData = new EventEmitter<any>();
  @ViewChild(SidebarFilterComponent) sidebarFilterComponent!: SidebarFilterComponent;
  @Output() openSurchargeModal = new EventEmitter<{ id: any }>();
  @ViewChild("op") assignOverlayPanel: OverlayPanel
  documentFieldList: any;
  isSuperuser: any;
  userDetails = JSON.parse(localStorage.getItem("userDetails"))
  saveClicked: boolean = false;
  displayDocuments: boolean = false;
  maxFileLimit: number;
  maxFileSize: number = 15000000;
  maxFileLimitPDF: any;
  uploadedFiles: any[] = [];
  @ViewChild('paginator', { static: true }) paginator: Paginator;
  @ViewChild('fileUpload') fileUpload: any;
  refresh_event_click_subscription: Subscription;
  page_size_list = Settings.GridConfiguration.pageSizeList;
  status = Settings.Status.booleanStatusList;
  operatorList= Settings.ToleranceOperators
  applicable_type = Settings.ApplicableType.ApplicableType
  reportType = Settings.ReportType.fetchReportType;
  rangeDates: Date[] | undefined;
  selectedReportType: any;
  maxDate = new Date();
  rotateState: string = 'default';
  timeoutId: any;
  error_message: { [key: string]: string[] } = {};
  iframeSafeUrl: 'assets/file/shipment.xlsx'
  excelUrl: SafeResourceUrl;
  // statusProcessingIcon: Number[] = [Settings.DocStatus.PROCESSING, Settings.DocStatus['PENDING VALIDATION'], Settings.DocStatus.VALIDATED, Settings.DocStatus['SENDING TO DESTINATION'],Settings.DocStatus['WAITING FOR AUTOCODING GENERATION']]
  // disableDestinationDownload: Number[] = [Settings.DocStatus.VALIDATED, Settings.DocStatus['WAITING FOR APPROVAL'], Settings.DocStatus['PENDING ACK'], Settings.DocStatus.COMPLETED, Settings.DocStatus['ON HOLD'],Settings.DocStatus['SENDING TO DESTINATION'],Settings.DocStatus['WAITING FOR REVIEW']];
  jumpToPageNo: string;
  lspType = Settings.LspType.LSPList;
  isFilterActive: boolean = false;
  showAssignConfirmModal: boolean = false;
  items: MenuItem[] = [
    {
      icon: 'fas fa-file-download',
      tooltipOptions: {
        tooltipLabel: "Export Excel",
        tooltipPosition: "left"
      },
      command: () => this.onClickExportExcel()
    },
    // {
    //   icon: 'fas fa-file-upload',
    //   tooltipOptions: {
    //     tooltipLabel: "Upload Document"
    //   },
    //   visible: this.router.url.includes('user/search/document-grid'),
    //   command: () => this.onClickUploadInvoice()
    // },
    {
      icon: 'fas fa-file-upload',
      tooltipOptions: {
        tooltipLabel: "Upload Excel"
      },
      visible: this.router.url.includes('user/master-data/po') || this.router.url.includes('user/master-data/shipment'),
      command: () => this.triggerFileUpload()
    },
  ];
  @ViewChild('fileInput') fileInput!: ElementRef;
  showColumnSettingsModal: boolean;
  user_schema: any = [];
  filtered_grid_schema: any[];
  user_grid_schema: any = [];
  hideUpdateDeleteButton: boolean;
  applicationList$: Observable<any>;
  applicationList: any[] = [];
  selectedClientId: any;
  uploadForm = new FormGroup({
    file_type: new FormControl(null, [Validators.required]),
    document_type: new FormControl(null, [Validators.required]),
  })
  docMasterStatus: { name: string; id: number }[] = [];
  displayUploadExcel: boolean;
  showFilePreview: boolean;
  excelViewerUrl!: SafeResourceUrl;
  selectedUserType: number;
  cardStatuses: any;
  handleFilter: boolean = false;
  showError: boolean;
  _selectedColumns!: Column[];
  tableHeader!: Column[];
  selectedDocument = null
  selectedBns: any = null
  filteredUsers: any = null;
  filterText = '';
  isTableExpanded: boolean = false
  isSearching = false
  bns_users = []
  order_by: any;
  is_export: boolean = false
  row_data: [] = [];
  user_name_details: any;
  user_id: any;
  AddCommentForm = new FormGroup({
    comment: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.pattern(Settings.RegexPattern.whiteSpace)])
  });
  documentToBeCancelled: any = null
  viewConfirmationModal = false
  constructor(private storageService: StorageService, private messageService: MessageService, public refreshService: CommonService, public masterdataService: MasterdataService, public documentService: DocumentsService, public router: Router, private store: Store<any>, public appMain: AppMainComponent, public commonService: CommonService, public adminService: AdministrationService, private http: HttpClient, private sanitizer: DomSanitizer, private cd: ChangeDetectorRef) {
    // this.userDetails$ = this.store.pipe(select(state => state));
    this.applicationList$ = this.store.pipe(select(state => state?.lists?.application));
  }

  ngOnInit() {

    this.selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
    this.appMain.configActive = false;
    this.getRefreshEvent();
    this.isSuperuser = this.userDetails.is_superuser
    this.hideUpdateDeleteButton = this.isSuperuser && !this.router?.url?.includes('data-change-logger') && !this.router?.url?.includes('/user-activity') && !this.router?.url?.includes('document-grid');
    if (this.module_id == Settings.Module.DOCUMENTS) {
      this.page_size_list = [10, 25, 50, 75, 100];
      this.getGridSchemaFilter();
      this.user_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
      setTimeout(() => {
        this.user_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
      }, 2000);
      // this.getUserSpecificColumnSettings();
    } else {
      this.getGridSchemaFilter();
      this.user_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
      setTimeout(() => {
        this.user_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
      }, 2000);
    }
    this.user_schema = JSON.parse(JSON.stringify(this.filtered_grid_schema));

    this.tableHeader = this.user_schema;
    this.tableHeader = this.tableHeader.map((item) => {
      if (item.key == 'transaction_id' || item.key === 'booking_number' || item.key === 'bl_number' || item.key === 'customer_name' || item.key === 'customer_sbu' || item.key === 'created_by') {
        return { ...item, isDisabled: true };
      } else {
        return { ...item, isDisabled: false };
      }
    });

    this.selectedColumns = [...this.tableHeader];
    const fileUrl = 'http://localhost:4200/assets/file/shipment.xlsx';
    const encodedUrl = encodeURIComponent(fileUrl);
    const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;

    this.excelViewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(viewerUrl);

    if (!this.user_name_details) {
      this.user_name_details = JSON.parse(localStorage.getItem('userNameDetails'));
    }
  }
  get selectedColumns(): Column[] {

    return this._selectedColumns;
  }

  set selectedColumns(val: Column[]) {

    //restore original order
    this._selectedColumns = this.tableHeader.filter((col) => val.includes(col));

  }
  refreshGrid() {
    this.sendRefreshClickEvent();
    this.resetTimer();
  }

  resetTimer() {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => this.refreshGrid(), Settings.AutoRefreshTime.refreshTimeInMilliSeconds); // 30 seconds
  }

  fetchDurationList() {
    this.durationType.emit(this.selectedReportType);
  }

  assignedInvoices() {
    this.assignedInvoiced.emit(this.isAssigned);
  }


  fetchDateRange() {
    this.dateRange.emit(this.rangeDates);
  }

  getBillingExport(e: any) {
    this.getBillingExportData.emit(e)
  }

  getClientBillingExport(e: any) {

    this.getClientBillingExportData.emit(e)
  }



  myfile: File;
  formdata = new FormData;

  triggerFileUpload() {
    this.fileInput.nativeElement.click();
  }

  onClickUploadExcelData(event: any) {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('excel_file', file);

    this.masterdataService.postShipment(formData).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'New Shipment Added Successfully' });
      },
      error: (e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: e.error?.message ?? 'Something Went wrong, Please Try Again'
        });
      }
    });
  }

  onClickUploadInvoice() {
    this.displayDocuments = true;
    this.maxFileLimit = this.maxFileLimitPDF;
  }

  onClickUploadExcel() {
    this.displayUploadExcel = true;
    this.maxFileLimit = this.maxFileLimitPDF;
  }

  previewExcelFile(byteArray: Uint8Array) {
    const blob = new Blob([byteArray], { type: 'assets/file/shipment.xlsx' });
    const url = window.URL.createObjectURL(blob);
    this.excelUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  handleFileRemove(event: any, fileUpload) {
    const errorState = fileUpload._files.length <= this.maxFileLimit;
    if (errorState) {
      fileUpload.msgs = [];
    }
    this.error_message = {}
    fileUpload.msgs = []
  }


  downloadExcel(): void {
    const fileName = 'shippment.xlsx';
    const fileUrl = `assets/file/shipment.xlsx`;

    this.http.get(fileUrl, { responseType: 'blob' }).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      // a.click();
      window.URL.revokeObjectURL(url);
    }, error => {
      console.error('Download failed', error);
    });
  }

  // onUploading(event, fileUpload) {
  //   const formData = new FormData();
  //   for (let file of event.files) {
  //     this.uploadedFiles.push(file);
  //   }
  //   formData.append('document_type', this.uploadForm.value.document_type);
  //   formData.append("file_type", this.uploadForm.value.file_type);
  //   if (this.uploadedFiles?.length > 0) {
  //     this.uploadedFiles.map((e, i) => {
  //       formData.append(`files`, this.uploadedFiles[i])
  //     })
  //     this.documentService.uploadDocument(formData).subscribe({
  //       next: (res) => {
  //         this.messageService.add({
  //           key: "emptyToster",
  //           severity: "info",
  //           summary: "File Processing",
  //           detail: "Please Wait While File is Processing, it will automatically reload once done",
  //           sticky: true,
  //         })
  //         setTimeout(() => {
  //           window.location.reload();
  //         }, 7000);
  //         fileUpload._files = [];
  //         this.uploadedFiles = [];
  //         event.files = []
  //         this.documentTypeList = [];
  //         this.fileTypelist = [];
  //         this.displayDocuments = false;
  //         this.messageService.add({ severity: 'success', summary: 'Successfully', detail: 'Invoice  has been Uploaded successfully' });
  //         window.location.reload();
  //       },
  //       error: (error) => {
  //         this.messageService.add({ severity: 'error', summary: 'Something Went Wrong', detail: error?.error?.error });
  //       }
  //     })
  //   }
  //   else {
  //     this.messageService.add({ severity: 'error', summary: 'Something Went Wrong', detail: 'Please Upload ' + this.maxFileLimit + ' files at a time Only' });
  //   }
  // }

  onUploading = async (event: any, fileUpload: any): Promise<void> => {
    const isManual = localStorage.getItem('manual-logged-in') === 'true';
    const formData = new FormData();
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }

    formData.append('document_type', this.uploadForm.value.document_type ?? '');
    formData.append('file_type', this.uploadForm.value.file_type ?? '');
    // formData.append('client_id', this.selectedClientId ?? '0');
    if (this.uploadedFiles?.length > 0) {
      this.uploadedFiles.map((e, i) => {
        formData.append(`files`, this.uploadedFiles[i])
      });

      try {
        this.messageService.add({
          key: "emptyToster",
          severity: "info",
          summary: "File Processing",
          detail: "Please Wait While File is Processing, it will automatically reload once done",
          sticky: true,
        });
        CommonService.showLoader()
        const response = await fetch(environment.baseApiUrl + `extraction/v1/upload?client_id=${this.selectedClientId} `, {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
          }
        });

        const text = await response.json();

        if (response.ok) {
          CommonService.hideLoader()
          if (this.router.url.includes('user/search/document-grid')) {
            localStorage.setItem("card_id", `${Settings.CardStatus.New}`)
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Invoice has been uploaded successfully'
          });

          fileUpload._files = [];
          this.uploadedFiles = [];
          event.files = [];
          this.documentTypeList = [];
          this.fileTypelist = [];
          this.displayDocuments = false;

          setTimeout(() => {
            window.location.reload();
          }, 300);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Upload Failed',
            detail: text.message || 'Something went wrong. Please try again.'
          });
        }
      } catch (error) {
        console.error('Upload Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Network Error',
          detail: 'Network error or server unavailable'
        });
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Upload Error',
        detail: `Please upload ${this.maxFileLimit} files at a time only`
      });
    }
  };


  clearFile() {
    this.uploadedFiles = [];
    this.error_message = {}
  }

  //excel upload
  // onExcelUploading(event, fileUpload) {
  //   const formData = new FormData();
  //   for (let file of event.files) {
  //     this.uploadedFiles.push(file);
  //   }

  //   if (this.uploadedFiles?.length > 0) {
  //     this.uploadedFiles.map((e, i) => {
  //       formData.append(`excel_file`, this.uploadedFiles[i])
  //     })
  //     this.documentService.uploadExcelDocument(formData).subscribe({
  //       next: (res) => {
  //         this.messageService.add({
  //           key: "emptyToster",
  //           severity: "info",
  //           summary: "File Processing",
  //           detail: "Please Wait While File is Processing, it will automatically reload once done",
  //           sticky: true,
  //         })
  //         setTimeout(() => {
  //           window.location.reload();
  //         }, 7000);
  //         fileUpload._files = [];
  //         this.uploadedFiles = [];
  //         event.files = []
  //         this.documentTypeList = [];
  //         this.fileTypelist = [];
  //         this.displayDocuments = false;
  //         this.messageService.add({ severity: 'success', summary: 'Successfully', detail: 'Invoice  has been Uploaded successfully' });
  //         window.location.reload();
  //       },
  //       error: (error) => {
  //         this.error_message = error?.error.errors;
  //         this.messageService.add({ severity: 'error', summary: 'Something Went Wrong', detail: error?.error?.error });
  //       }
  //     })
  //   }
  //   else {
  //     this.messageService.add({ severity: 'error', summary: 'Something Went Wrong', detail: 'Please Upload ' + this.maxFileLimit + ' files at a time Only' });
  //   }
  // }

  onExcelUploading = async (event: any, fileUpload: any): Promise<void> => {
    const formData = new FormData();

    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }

    if (this.uploadedFiles?.length > 0) {
      this.uploadedFiles.forEach(file => {
        formData.append('excel_file', file);
      });

      try {
        this.messageService.add({
          key: "emptyToster",
          severity: "info",
          summary: "File Processing",
          detail: "Please Wait While File is Processing, it will automatically reload once done",
          sticky: true,
        });

        const response = await fetch(environment.baseApiUrl + `master/v1/shipments/create/excel?client_id=${this.selectedClientId}`, {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
          }
        });

        const text = await response.text();

        let errorJson;
        try {
          errorJson = JSON.parse(text);
        } catch {
          errorJson = null;
        }

        if (response.ok) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Invoice has been uploaded successfully',
          });

          fileUpload._files = [];
          this.uploadedFiles = [];
          event.files = [];
          this.documentTypeList = [];
          this.fileTypelist = [];
          this.displayDocuments = false;
          this.error_message = {}
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {

          if (errorJson?.errors && Array.isArray(errorJson.errors)) {
            errorJson.errors.forEach((err: any) => {
              const rowKey = `Row ${err.row}`;
              const messages: string[] = [];

              for (const [field, message] of Object.entries(err.fields)) {
                messages.push(`${field}: ${message}`);
              }

              this.error_message[rowKey] = messages;
            });
          }
          let errorMessage = errorJson?.message
          this.messageService.add({

            severity: 'error',
            summary: 'Upload Failed',
            detail: errorMessage || 'Something went wrong. Please try again.'
          });
        }
      } catch (error) {
        console.error('Excel Upload Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Network Error',
          detail: 'Network error or server unavailable'
        });
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Upload Error',
        detail: `Please upload ${this.maxFileLimit} files at a time only`
      });
    }
  };


  ngOnChanges(changes: SimpleChanges): void {
    this.docMasterStatus = Object.keys(Settings.DocStatus)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        name: this.formatActionName(key),
        id: Settings.DocStatus[key as keyof typeof Settings.DocStatus]
      }));

    this.selectedUserType = Number(localStorage.getItem('selectedUserType'));

    this.selectedUserType = Number(localStorage.getItem('selectedUserType'));

    this.selectedUserType = Number(localStorage.getItem('selectedUserType'));
    const hasClientId = !!localStorage.getItem('selectedClientId'); // 👈 check client id

    if (hasClientId) {
      // Always show INTERNAL + EXTERNAL when clientId exists
      this.userTypeList = Object.keys(Settings.UserTypeEnum)
        .filter(key => isNaN(Number(key)) && (key === 'INTERNAL_USER' || key === 'EXTERNAL_USER'))
        .map(key => ({
          name: this.formatActionName(key),
          id: Number(Settings.UserTypeEnum[key as keyof typeof Settings.UserTypeEnum])
        }));
    } else {
      // Otherwise only COZENTUS_USER
      this.userTypeList = Object.keys(Settings.UserTypeEnum)
        .filter(key => isNaN(Number(key)) && key === 'COZENTUS_USER')
        .map(key => ({
          name: this.formatActionName(key),
          id: Number(Settings.UserTypeEnum[key as keyof typeof Settings.UserTypeEnum])
        }));
    }


    if (this.module_id == Settings.Module.DOCUMENTS) {
      const filterKeys = {
        "currency": this.currencyList,
        "current_status": this.docMasterStatus,
        'document_type': this.documentTypeList,
        'file_type': this.fileTypelist,
        'customer_name': this.allcustomerList
      };

      setTimeout(() => {
        if (changes['docMasterStatus'] || changes['currencyList'] || changes['documentTypeList'] || changes['allcustomerList'] || changes['fileTypelist'] || changes['userTypeList']) {
          this.grid_schema?.forEach((col) => {
            if (filterKeys[col.key]) {
              col.filter_options = filterKeys[col.key];
            }
          });
          this.user_grid_schema?.forEach((col) => {
            if (col.filter_type !== 'input' || col.filter_type !== 'calendar' || col.filter_type !== 'dropdown' || col.filter_type !== 'multiselect') {
              if (this.module_id == Settings.Module.DOCUMENTS) {
                if (col.key == 'current_status') {
                  col.filter_options = this.docMasterStatus;
                }
                if (col.key == 'document_type') {
                  col.filter_options = this.documentTypeList;
                }
                if (col.key == 'customer_name') {
                  col.filter_options = this.allcustomerList;
                }
                if (col.key == 'currency') {
                  col.filter_options = this.currencyList;
                }
                if (col.key == 'file_type') {
                  col.filter_options = this.fileTypelist;
                }
              }
            }
          });
          this.filtered_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
          if (this.user_schema?.length == 0) {
            this.user_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
            this.user_schema = JSON.parse(JSON.stringify(this.grid_schema));
          }
        }
      }, 50)

    }
    else {


      const filterKeys = {
        'document_type': this.documentTypeList,
        'customer_name': this.allcustomerList,
        'percentage_operator':this.operatorList,
        'delta_operator':this.operatorList,
        'file_types': this.fileTypeList,
        'file_type': this.fileTypeList,
        'feature': this.featureList,
        'currency': this.currencyList,
        'total_surcharges_currency':this.currencyList,
        'grand_total_currency':this.currencyList,
        'surcharge_currency':this.currencyList,
        'applicable_type':this.applicable_type,
        'user_type': this.userTypeList,
        'from_currency': this.currencyList,
        'to_currency': this.currencyList,
        'email_type_name': this.emailType,
        'address_type': this.address_type_list,
        'feature_name': this.featureList,
        'shipper': this.vendorList,
        'consignee': this.customerList,
        'category_type': this.serviceCategory,
        'service_type': this.serviceType,
        'transport_mode': this.transportMode,
        'connectivity_protocol': this.connectivityProtocol,
        'direction': this.directionList,
        'sector': this.sectorList,
      };



      setTimeout(() => {
        if (changes['documentTypeList'] ||
          changes['all'] ||
          changes['fileTypeList'] ||
          changes['filteredFileTypes'] ||
          changes['currencyList'] ||
          changes['userTypeList'] ||
          changes['emailType'] ||
          changes['vendorList'] ||
          changes['customerList'] ||
          changes['transportMode'] ||
          changes['serviceCategory'] ||
          changes['serviceType'] ||
          changes['address_type_list'] ||
          changes['companyList'] ||
          changes['directionList'] ||
          changes['connectivityProtocol'] ||
          changes['sectorList']
        ) {
          this.grid_schema?.forEach((col) => {
            if (filterKeys[col.key]) {
              col.filter_options = filterKeys[col.key];
            }
          });




          this.user_grid_schema?.forEach((col) => {

            if (col.filter_type !== 'input' && col.filter_type !== 'calendar') {
              if (col.key == 'document_type') {
                col.filter_options = this.documentTypeList;
              } else if (col.key == 'customer_name') {
                col.filter_options = this.allcustomerList;
              } else if (col.key == 'file_type') {
                col.filter_options = this.filteredFileTypes;
              } else if (col.key == 'roles') {
                col.filter_options = this.roleList;
              } else if (col.key == 'currency') {
                col.filter_options = this.currencyList;
              } else if (col.key == 'user_type') {
                col.filter_options = this.userTypeList;
              } else if (col.key == 'file_types') {
                col.filter_options = this.fileTypeList;
              } else if (col.key == 'file_type') {
                col.filter_options = this.fileTypeList;
              } else if (col.key == 'from_currency') {
                col.filter_options = this.currencyList;
              } else if (col.key == 'to_currency') {
                col.filter_options = this.currencyList;
              } else if (col.key == 'consignee') {
                col.filter_options = this.customerList;
              } else if (col.key == 'shipper') {
                col.filter_options = this.vendorList;
              } else if (col.key == 'category_type') {
                col.filter_options = this.serviceCategory;
              } else if (col.key == 'service_type') {
                col.filter_options = this.serviceType;
              } else if (col.key == 'transport_mode') {
                col.filter_options = this.transportMode;
              } else if (col.key == 'feature_name') {
                col.filter_options = this.featureList;
              } else if (col.key == 'sector') {
                col.filter_options = this.sectorList;
              } else if (col.key == 'connectivity_protocol') {
                col.filter_options = this.connectivityProtocol;
              } else if (col.key == 'direction') {
                col.filter_options = this.directionList;
              }
            }
          });

          this.filtered_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
          if (this.user_schema?.length == 0) {
            this.user_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
            this.user_schema = JSON.parse(JSON.stringify(this.grid_schema));
          }

        }
      }, 50);

    }
    if (changes['selectedCard']) {
      this.cardStatuses = this.selectedCard;
      this.isAssigned = false
    }

    if (this.filterText == "") {
      this.filteredUsers = this.bns_users
    }

  }

  formatActionName(action: string): string {
    return action.replace(/_/g, " ") // Replace underscores with spaces
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
  }


  getUserSpecificColumnSettings() {
    this.adminService.getUserColumnSettingsList(this.module_id, this.selectedClientId).subscribe({
      next: (res: any) => {
        let data = res?.result?.payload;
        let parsedData: any;
        try {
          const preprocessedString = data
            .replace(/'/g, '"')
            .replace(/None/g, 'null')
            .replace(/False/g, 'false')
            .replace(/True/g, 'true');
          parsedData = JSON.parse(preprocessedString);
          Object.keys(parsedData).forEach(key => {
            const value = parsedData[key];
            if (typeof value === 'string' && (value.trim().startsWith('{') || value.trim().startsWith('['))) {
              try {
                parsedData[key] = JSON.parse(value);
              } catch (innerError) {
                console.error(`Error parsing nested JSON for key ${key}:`, innerError);
              }
            }
          });
        } catch (error) {
          parsedData = data;
        }
        if (res?.result?.module_id) {
          this.user_grid_schema = parsedData?.filter(col => col.is_selected);
          this.user_schema = parsedData ?? [];
          this.user_grid_schema.forEach((col) => {
            if (col.filter_type !== 'input' && col.filter_type !== 'calendar') {
              if (this.module_id == Settings.Module.DOCUMENTS) {
                if (col.key == 'business_unit_code') {
                  col.filter_options = this.businessUnitList;
                }
                if (col.key == 'document_type_name') {
                  col.filter_options = this.doc_type_list;
                }
                if (col.key == 'customer_name') {
                  col.filter_options = this.allcustomerList;
                }
                if (col.key == 'country_code') {
                  col.filter_options = this.currencyList;
                }
                if (col.key == 'file_type') {
                  col.filter_options = this.fileTypelist;
                }
                if (col.key == 'user_type') {
                  col.filter_options = this.userTypeList;
                }
              }
            }
          });
        } else {
          this.user_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
          this.user_schema = JSON.parse(JSON.stringify(this.grid_schema));
        }
      },
      error: (error) => {
        this.user_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
        this.user_schema = JSON.parse(JSON.stringify(this.grid_schema));
      }
    })
  }

  onClickShowColumnSettingsModal() {
    this.showColumnSettingsModal = true;
  }

  onClickResetColumnSettings() {
    this.user_schema = JSON.parse(JSON.stringify(this.filtered_grid_schema));
  }

  onHideColumnSettings() {
    if (!this.saveClicked) {
      this.onClickResetColumnSettings();
    }
    this.saveClicked = false;
  }

  onClickSaveColumnSettings() {
    let selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
    let body = {
      payload: this.user_schema,
      module_id: this.module_id,
      client_id: selectedClientId
    }
    this.adminService.postUserColumnSettings(body).subscribe({
      next: (res) => {
        this.saveClicked = true;
        this.user_grid_schema = JSON.parse(JSON.stringify(this.user_schema.filter(col => col.is_selected)));
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Column Settings has been updated successfully' });
        this.showColumnSettingsModal = false;
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.message ?? 'Something Went wrong, Please Try Again' });
        this.showColumnSettingsModal = false;
      }
    })
  }

  getGridSchemaFilter() {
    this.grid_schema.forEach((col) => {
      if (col.filter_type !== 'input' && col.filter_type !== 'calendar') {

        if (window.location.href.includes('/search/document-grid')) {
          if (col.is_library_available) {
            this.fetchDropdownOptions(col);
          }
          if (col.key == 'business_unit_code') {
            col.filter_options = this.businessUnitList;
          }
          if (col.key == 'document_type_name') {
            col.filter_options = this.doc_type_list;
          }
          if (col.key == 'customer_name') {
            col.filter_options = this.allcustomerList;
          }
          if (col.key == 'country_code') {
            col.filter_options = this.currencyList;
          }
          if (col.key == 'file_type') {
            col.filter_options = this.fileTypelist;
          }
          if (col.key == 'user_type') {
            col.filter_options = this.userTypeList;
          }
        } else {
          if (col.is_library_available) {
            this.fetchDropdownOptions(col);
          }
          else if (col.key == 'is_active') {
            col.filter_options = this.status;
          }
           else if (col.key == 'applicable_type') {
            col.filter_options = this.applicable_type;
          }
          else if(col.key == 'percentage_operator'){
            col.filter_options = this.operatorList;
          }
          else if(col.key == 'delta_operator'){
            col.filter_options = this.operatorList;
          }
          else if (col.key == 'service_level_type') {
            col.filter_options = this.lspType;
          }
          else if (col.key == 'client_name') {

          } else if (col.key == 'type') {
            col.filter_options = this.companyType;
          }
          else if (col.key == 'companies') {
            col.filter_options = this.companyList;
          }
          else if (col.key == 'roles') {
            col.filter_options = this.roleList;
          }
          else if (col.key == 'user_type') {
            col.filter_options = this.userTypeList;
          }
          else {
            col.filter_options = [];
          }
        }
      }
    });
    this.filtered_grid_schema = JSON.parse(JSON.stringify(this.grid_schema));
  }

  onClickReset() {
    this.documentFieldList = [];
    this.rangeDates = undefined;
    this.selectedReportType = null
    if (!this.filterModel) {
      this.filterModel = {};
    }
    if (!this.filterModel.data_elements) {
      this.filterModel.data_elements = {};
    } else {
      this.filterModel.data_elements = {};
    }
    this.resetFilters.emit();
    if (this.sidebarFilterComponent) {
      this.sidebarFilterComponent.templateData = null;
      this.sidebarFilterComponent.showUpdate = false;
    }
    this.closeSidebar();
    window.location.reload();
  }

  onClickDownloadUploadedFile(file) {
    this.downloadFileData.emit(file)
  }

  onClickDownloadAttachment(file_content, file_name) {
    let downloadUrl = CommonService.generateFileUrl(file_content, file_name);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.target = '_blank'
    link.download = file_name ?? 'Freight Audit_Attachment'; // Specify the desired file name here
    link.click();
    window.URL.revokeObjectURL(downloadUrl);
  }

  onConfigButtonClick(event) {
    this.appMain.configActive = !this.appMain.configActive;
    this.appMain.configClick = true;
    event.preventDefault();
  }

  getRefreshEvent() {
    this.refresh_event_click_subscription = this.commonService.getRefreshEvent().subscribe((res) => {
      const event = { page: this.page_number - 1 } as Partial<Event>;
      this.paginate(event);
    })
  }

  onClickAddUpdateModal() {
    if (this.callback) {
      this.callback(true);
    }
  }

  onDateSelect(data: { event: any, colKey: string }) {
    let event = data.event;
    let colKey = data.colKey;
    if (event) {
      this.filterModel[`${colKey}_start_date`] = event[0] ? moment(event[0]).format(Settings.DateFormats.dateFormatOnlyDate) : null;
      this.filterModel[`${colKey}_end_date`] = event[1] ? moment(event[1]).format(Settings.DateFormats.dateFormatOnlyDate) : null;
    } else {
      this.filterModel[`${colKey}_start_date`] = null;
      this.filterModel[`${colKey}_end_date`] = null;
    }
  }

  onDateSelectGrid(event: any, colKey: string) {
    if (event) {
      this.filterModel[`${colKey}_start_date`] = event[0] ? moment(event[0]).format(Settings.DateFormats.dateFormatOnlyDate) : null;
      this.filterModel[`${colKey}_end_date`] = event[1] ? moment(event[1]).format(Settings.DateFormats.dateFormatOnlyDate) : null;
    } else {
      this.filterModel[`${colKey}_start_date`] = null;
      this.filterModel[`${colKey}_end_date`] = null;
    }
  }

  onClickDelete(id: string) {
    if (this.delete) {
      this.delete(id);
    }
  }

  onClickEdit(data, id) {
    if (this.edit) {
      this.edit(data, id);
    }
  }

  getErrorRows(): string[] {
    return this.error_message ? Object.keys(this.error_message) : [];
  }


  processUploadErrors(errors: any[]) {
    this.error_message = {};
    errors.forEach(err => {
      this.error_message[err.row] = Object.values(err.fields);
    });
  }

  onClickAddSubscription(data) {
    if (this.addSubscription) {
      this.addSubscription(data);
    }
  }

  onClickAddConnectivitySetup(data) {
    if (this.addConnectivitySetup) {
      this.addConnectivitySetup(data);
    }
  }

  onClickViewConnectivitySetup(data, id) {
    if (this.viewConnectivitySetup) {
      this.viewConnectivitySetup(data, id);
    }
  }

  onClickEditConnectivitySetup(data, id) {
    if (this.editConnectivitySetup) {
      this.editConnectivitySetup(data, id);
    }
  }

  onClickDeleteConnectivitySetup(id) {
    if (this.deleteConnectivitySetup) {
      this.deleteConnectivitySetup(id);
    }
  }

  onClickGoToItemDetailsPage(data) {
    this.router.navigate([`/user/master-data/po-item/${data?.id}/${data?.po_number}`])
  }

  onClickGoToRulesPage(data) {
    this.router.navigate([`/user/master-data/rules/${data?.id}`])
  }

  onClickViewSubscription(data) {
    if (this.viewSubscription) {
      this.viewSubscription(data);
    }
  }

  onClickCopy(data) {
    if (this.copy) {
      this.copy(data);
    }
  }

  fetchDropdownOptions(col: any) {
    this.adminService.getDocumentFieldLibrary({ "document_field": col.id }).subscribe({
      next: (options: any) => {
        col.filter_options = options?.results.map((option: any) => ({
          name: option.key,
          value: option.value
        }));
      },
      error: (err) => {
        console.error(`Error fetching dropdown options for column ${col.label}:`, err);
      }
    });
  }

  onClickExportExcel() {
    if (!this.data || this.data.length === 0) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data available to export' });
      return;
    }
    if (this.export) {
      this.export();
    }
  }

  clearFilterModel() {
    this.filterModel = {};
  }

  populateFilterTemplateData(data) {

    this.filterModel = data;
    const findDateKeys = (obj) => {
      return Object?.keys(obj).filter(key => key?.includes('_on') || key?.includes('_date'));
    };
    const dateKeys = findDateKeys(data);
    dateKeys.forEach(dateKey => {
      if (data?.[dateKey]) {
        const dateValue = data[dateKey];
        if (Array.isArray(dateValue) && dateValue.length > 0) {
          let [firstDate, secondDate] = dateValue;
          if (!firstDate && secondDate) {
            firstDate = secondDate;
          }
          if (!secondDate && firstDate) {
            secondDate = firstDate;
          }
          this.filterModel[dateKey] = [new Date(firstDate), new Date(secondDate)];
        } else {
          this.filterModel[dateKey] = null;
        }
      }
    })
    setTimeout(() => {
      dateKeys.forEach(dateKey => {
        if (this.filterModel[dateKey] && Array.isArray(this.filterModel[dateKey])) {
          const formattedDates = this.filterModel[dateKey].map(date => {
            return date instanceof Date ? moment(date).format(Settings.DateFormats.dateFormatOnlyDate) : date;
          });
          this.onDateSelectGrid(formattedDates, dateKey);
        }
      });
      this.filterModelChange.emit(this.filterModel);
    }, 1000);
  }

  onClickFilter() {
    if (this.module_id == Settings.Module.DOCUMENTS) {
      if (!this.filterModel) {
        this.filterModel = {};
      }
      this.filterModel.document_type_id = this.filterModel?.document_type_name || 0;
    }
    this.filterModelChange.emit(this.filterModel);
    if (this.data?.length > 0) {
      this.paginator.changePage(0);
    } else {
      const event = { page: this.page_number - 1 } as Partial<Event>;
      this.paginate(event);
    }
    this.closeSidebar();
  }

  paginate(event) {
    if (this.paginateEvent) {
      let data = {
        ...event,
        orderType: this.order_type,
        orderBy: this.default_order_by,
        user_type: 15
      }
      this.paginateEvent(data);
    }
  }

  sortColumn(event) {
    this.default_order_by = event?.sortField;
    this.order_type = event?.sortOrder;
    if (this.sortGrid) {
      if (this.page_number == 1) {
        this.sortGrid(event);
      } else {
        this.paginator.changePage(0);
      }
    }
  }

  jumpToPage(event) {
    if (event.target.value) {
      if (event.target.value <= this.paginator.paginatorState.pageCount) {
        this.paginator.changePage((event.target.value - 1));
        this.jumpToPageNo = "";
      }
    }
  }

  onClickNavigateToDocumentFieldConfig(data) {
    this.router.navigate([`/user/admin/document-field/${data?.application_id}/${data?.id}`])
  }

  onClickViewPDF(data) {
    if (this.viewPdf) {
      this.viewPdf(data);
    }
  }

  onClickViewConfig(data) {
    if (this.viewConfig) {
      this.viewConfig(data);
    }
  }

  onClickPayloadIcon(data) {
    this.payloadData.emit(data);
  }

  onChangeSuperUser(event, data) {
    let userData = {
      ...event,
      ...data
    }
    this.superUserEvent.emit(userData);
  }

  onAssignDB(event, data) {
    const userData = {
      "client_id": data?.id,
      "db_name": data?.name
    }
    this.commonService.assignDB(userData).subscribe({
      next: (res: any) => {
      },
      error: () => {

      }
    })
  }

  onClickViewPrivileges(data) {
    this.privilegeData.emit(data);
  }

  onClickViewSbuList(data) {
    this.sbuData.emit(data);

  }

  onClickViewVendor(data) {
    this.vendor.emit(data);

  }
  onClickViewCustomer(data) {
    this.customer.emit(data);

  }

  onClickViewApplicationPrivileges(data) {
    this.applicationData.emit(data);
  }

  onClickViewSuperUserApplicationPrivileges() {
    this.superUserData.emit();
  }

  onClickGenerateToken(data) {
    this.appToken.emit(data);
  }

  closeSidebar() {
    this.showFilter = false;
    // this.filterModel.document_type_name=this.filterModel.document_type_id;
  }

  oClickViewVersions(data) {
    this.viewVersion.emit(data);
  }

  ngOnDestroy() {
    this.refresh_event_click_subscription.unsubscribe();
  }

  getRoleName(document) {
    let selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
    const roleData = document?.role_data?.find(role => role.application_id === selectedClientId);
    return roleData?.role_name ?? null;
  }

  getApplicationName(document) {
    const data = this.applicationList?.find(application => application.id === document?.application_id);
    return data?.application_name ?? null;
  }

  onClickApplyOptionsFilter(options) {
    options.hide();
    this.onClickFilter();
  }

  onClickClearOptionsFilter(options, key) {
    this.filterModel[key] = null;
    options.hide();
    this.onClickFilter();
  }

  hasFilterValues(): boolean {
    if (!this.filterModel) {
      return false;
    }
    return Object.values(this.filterModel).some(value => {
      if (value == null) {
        return false;
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === 'object') {
        return Object.values(value).some(val => val != null && val !== '');
      }
      return value !== '';
    });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event?.key == 'Enter' && !event?.shiftKey) {
      if (this.showFilter) {
        this.onClickFilter();
      }
    }
    if (event.ctrlKey && event.key === 'r') {
      event.preventDefault(); // Prevent default browser behavior (refreshing the page)
      this.sendRefreshClickEvent(); // Call your function
    }
  }

  sendRefreshClickEvent() {
    this.rotate();
  }

  rotate() {
    this.rotateState = (this.rotateState === 'default' ? 'rotated' : 'default');
  }

  onClickNavigateToController(data) {
    if (data?.template_name) {
      this.router.navigateByUrl('/user/admin/email-template-controller/' + data?.id);
    }

  }

  getStatusClass(col: any, document: any): any {
    if (col?.label === 'Status') {
      const status = (document?.[col.key] || '').toLowerCase().replace(/\s+/g, '-');

      return {
        'status-badge': true,
        [status]: true
      };
    }
    return {};
  }

  // getSubStatusDetails(col: any, document: any): any {
  //   if (col?.label === 'Sub-Status') {
  //     if(){
  //       return `Assigned & ${status}`
  //     }else{
  //       return status;
  //     }
  //   }
  //   return "";
  // }

  onDialogClose() {
    this.uploadForm.reset(); // Reset the form

    // Optional: Clear uploaded files from the fileUpload component if needed
    if (this.fileUpload) {
      this.fileUpload.clear();
    }
  }

  handleAddClick(id: any) {
    this.openSurchargeModal.emit({ id });
  }

  debounceFilter() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.onClickFilter();
    }, 50);
  }

  toggleTableFilter() {
    this.handleFilter = !this.handleFilter
  }

  onClickAssign(event: MouseEvent, overlayPanel: OverlayPanel, document: any, docId: any) {
    this.selectedDocument = document;
    this.filterText = '';
    this.filteredUsers = this.bns_users; // or however you get this list
    this.getBNSOperators(document.customer_name, document?.vendor_name)
    overlayPanel.toggle(event);
  }

  onClickCancel(document) {
    this.AddCommentForm.reset()
    this.documentToBeCancelled = document
    this.viewConfirmationModal = true
  }

  onHideCancel() {
    this.documentToBeCancelled = null
    this.AddCommentForm.reset()
    this.viewConfirmationModal = false
  }

  cancelDocumentAction() {
    let body = {
      "update_field": {},
      "line_items": [],
      "document_id": [this.documentToBeCancelled.id],
      "client_id": JSON.parse(localStorage.getItem('selectedClientId') || null),
      "action_type": "DISCARD",
      "is_edited": false,
      "is_locked": true,
      "is_saved": false,
      "remark": this.AddCommentForm.value.comment || null,
      "for_audit": false
    }

    this.documentService.updateDocumentData(body).subscribe({
      next: (res) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document Data Updated Successfully' });
        this.viewConfirmationModal = false;
        this.AddCommentForm.reset()
        setTimeout(() => {
          window.location.reload()
        }, 800)
      }, error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.message ?? 'Failed to Update Document Data' });
        this.viewConfirmationModal = false;
        this.AddCommentForm.reset()
      }
    })
  }

  // disabledLabels = new Set(['Status','Booking Number','BL Number']);
  // disableColumnOption = (option: any): boolean => {
  //   return this.disabledLabels.has(option.label);
  // };

  validateSelection(event: any) {
    this.user_grid_schema = this.tableHeader.filter((col) =>
      event.value.includes(col)
    );
    const selectedIds = this.user_grid_schema.map((col) => col.id);
    this.user_grid_schema = this.user_schema.filter((item: any) =>
      selectedIds.includes(item.id)
    );
  }

  onFilterChange(event: any) {
    const value = event.target.value?.toLowerCase() || '';
    this.filteredUsers = this.bns_users.filter(user => {
      const firstName = user.first_name?.toLowerCase() || '';
      const lastName = user.last_name?.toLowerCase() || '';
      return (firstName + " " + lastName).includes(value) || (lastName + " " + firstName).includes(value);
    });
    this.cd.detectChanges()
  }

  getBNSOperators(customer_sbu, vendor) {
    this.isSearching = true
    const body = {
      client_id: JSON.parse(localStorage.getItem('selectedClientId')) ?? null,
      module_id: Settings.Module.USER_MANAGEMENT,
      user_type: 10,
      sbu_by_name: customer_sbu,
      vendor_by_name: vendor,
      page_size: 600
    }


    this.adminService.getAllUserWithoutLoader(body).subscribe({
      next: (res: any) => {
        this.isSearching = false
        this.bns_users = res?.results.filter((element: any) => !element?.is_delete && element?.role_name == "BNS Admin" || element?.role_name == "BNS Operator");
        // body.client_id = null
        // body.user_type = 5
        // this.adminService.getAllUser(body).subscribe({
        //   next:(res:any)=>{

        //     this.bnsOperators = res?.results.filter((element: any) => !element?.is_delete);
        //   },
        //   error:(err:any)=>{
        //     console.error(err)
        //   }
        // })
      },
      error: (err: any) => {
        this.isSearching = false
        console.error(err)
      }
    })
  }

  onSelectBnsOperator(user) {
    this.selectedBns = user
    this.showAssignConfirmModal = true
    this.assignOverlayPanel.hide()
  }

  onAssignOverlayPanelHide() {
    this.assignOverlayPanel.hide()
  }

  onApproveAssign() {
    this.assign(this.selectedDocument, this.selectedBns.id)
    this.showAssignConfirmModal = false
  }

  onCancelAssign() {
    this.showAssignConfirmModal = false
  }

  toggleTableExpansion() {
    this.isTableExpanded = !this.isTableExpanded
  }

  // hideAssignReassignCol(col_name){
  //   if(this.selectedCard == )
  // }
}